import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 shadow-sm">
        <div className="container mx-auto px-6 py-6">
          <Button 
            variant="ghost" 
            onClick={() => window.location.href = '/'}
            className="flex items-center gap-2 text-slate-700 hover:text-red-600"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Button>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-4xl font-bold text-slate-900 mb-8">Impressum</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-8">
          {/* Angaben gemäß § 5 TMG */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="space-y-2 text-slate-700">
              <p className="font-semibold text-lg">Executive Air GmbH</p>
              <p>Postbox 679240</p>
              <p>11516 Berlin</p>
              <p>Deutschland</p>
            </div>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Kontakt</h2>
            <div className="space-y-2 text-slate-700">
              <p><span className="font-medium">Telefon:</span> +172 4331334</p>
              <p><span className="font-medium">E-Mail:</span> info@executive-air.eu</p>
              <p><span className="font-medium">Buchungen:</span> booking@executive-air.eu</p>
              <p className="mt-4"><span className="font-medium">Flight Operations Center (FOC):</span></p>
              <p>@ Airport Trier-Foehren (EDRT)</p>
              <p>Europa-Allee 62</p>
              <p>D-54343 Föhren</p>
            </div>
          </section>

          {/* Vertretungsberechtigte */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Vertreten durch</h2>
            <div className="space-y-2 text-slate-700">
              <p>Frank Zurmühlen</p>
              <p>Dr. Sven Mühlenbrock</p>
            </div>
          </section>

          {/* Registereintrag */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Registereintrag</h2>
            <div className="space-y-2 text-slate-700">
              <p><span className="font-medium">Eintragung im Handelsregister:</span></p>
              <p>Registergericht: Amtsgericht Oldenburg</p>
              <p>Registernummer: HRB 216767</p>
              <p className="mt-2"><span className="font-medium">Sitz der Gesellschaft:</span></p>
              <p>Luise-Uhlhorn-Str. 6</p>
              <p>26188 Edewecht</p>
            </div>
          </section>

          {/* Umsatzsteuer-ID */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Umsatzsteuer-ID</h2>
            <div className="space-y-2 text-slate-700">
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</p>
              <p className="font-medium">DE343019435</p>
              <p className="mt-2">Finanzamt Westerstede</p>
              <p className="mt-2 text-sm">Leistungen i.V.m. grenzüberschreitendem Luftverkehr i.S.d. §4 Nr.2 i.V.m. §8 (2) UStG sind von der Umsatzsteuer befreit.</p>
            </div>
          </section>

          {/* Verantwortlich für den Inhalt */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <div className="space-y-2 text-slate-700">
              <p>Frank Zurmühlen, Dr. Sven Mühlenbrock</p>
              <p>Postbox 679240</p>
              <p>11516 Berlin</p>
            </div>
          </section>

          {/* EU-Streitschlichtung */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">EU-Streitschlichtung</h2>
            <div className="space-y-2 text-slate-700">
              <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:</p>
              <p><a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">https://ec.europa.eu/consumers/odr/</a></p>
              <p className="mt-2">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            </div>
          </section>

          {/* Verbraucherstreitbeilegung */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
            <div className="space-y-2 text-slate-700">
              <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
            </div>
          </section>

          {/* Haftungsausschluss */}
          <section>
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">Haftungsausschluss</h2>
            
            <h3 className="text-xl font-medium text-slate-900 mt-6 mb-3">Haftung für Inhalte</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>

            <h3 className="text-xl font-medium text-slate-900 mt-6 mb-3">Haftung für Links</h3>
            <p className="text-slate-700 leading-relaxed mb-4">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>

            <h3 className="text-xl font-medium text-slate-900 mt-6 mb-3">Urheberrecht</h3>
            <p className="text-slate-700 leading-relaxed">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
          </section>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center text-sm text-slate-500">
          <p>Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="hover:text-red-600">e-recht24.de</a></p>
        </div>
      </div>
    </div>
  );
};
